import classNames from "classnames/bind";

import styles from "./GoogleMapsEmbed.module.scss";

const cx = classNames.bind(styles);

const API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;

export type GoogleMapsEmbedProps = {
    geolocation: any;
};

const GoogleMapsEmbed = (props: GoogleMapsEmbedProps) => {
    const zoom = 18;
    const mapScale = 591657550.5 / Math.pow(2, zoom + 1);
    const base64 = btoa(props.geolocation);

    return (
        <iframe
            className={cx("mapsContainer")}
            style={{ border: 0 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps/embed?key=${API_KEY}&pb=!1m7!1m2!1m1!1d${mapScale}!3m3!1m2!1s0!2z${base64}`}
        />
    );
};

export default GoogleMapsEmbed;
